module.exports = __webpack_public_path__ + "static/media/HRECOS_Stations_Port_of_Albany.1e3fe3b7.jpg";